module.exports = __webpack_public_path__ + "img/new_29.49f37d0e.jpg";